import { Customer } from "../../auth/Auth";
import { validateEmail } from "../../../helpers/validation";

export interface CustomerErrors {
    name?: string;
    address?: string;
    email?: string;
    phoneNumber?: string;
}

export const validateForm = (customer: Customer | null): { valid: boolean; errors: CustomerErrors } => {
    const errors: CustomerErrors = {};

    //Validate name
    if (!customer?.name.trim()) {
        errors.name = "Polje je obavezno.";
    }

    //Validate address
    if (!customer?.address.trim()) {
        errors.address = "Polje je obavezno.";
    }

    //Validate phoneNumber
    if (!customer?.phoneNumber.trim()) {
        errors.phoneNumber = "Polje je obavezno.";
    }

    //Validate email
    if (!customer?.email.trim()) {
        errors.email = "Polje je obavezno.";
    } else if (!validateEmail(customer?.email)) {
        errors.email = "Pogrešan format email adrese.";
    }

    return {
        valid: Object.keys(errors).length === 0,
        errors
    };
};